<template>
  <BCard>
    <div class="text-black text-[20px] mb-2 font-[600]">
      System Update Log
    </div>
    <div class="flex md:flex-row flex-column justify-between mt-1 mb-3">
      <div class="flex items-center gap-3">
        <b-button
          v-if="selected.length >= 1"
          variant="flat-danger"
          class="!relative !flex items-center justify-center !bg-[#FFF2F2] !border-0 !rounded-[8px] !py-4 !px-4 !gap-2 !cursor-pointer"
          @click="deleteSelected()"
        >
          <span class="text-[#E52E2E] text-[15px]">Hapus</span>
          <img
            src="https://storage.googleapis.com/komerce/assets/svg/trash-red.svg"
            alt="delete"
            width="16"
            height="16"
          >
          <span
            class="absolute top-[-5px] right-[-10px] bg-[#E52E2E] text-white rounded-full w-6 h-6 text-[12px] font-bold leading-none flex items-center justify-center"
          >
            {{ selected.length }}
          </span>
        </b-button>
      </div>
      <div class="d-flex flex-column flex-md-row justify-content-end">
        <b-form-group class="mb-0 text-end d-flex flex-md-row flex-column">
          <div class="d-flex flex-md-row flex-column gap-5">
            <b-input-group
              class="input-group-merge"
              size="md"
            >
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="filterInput"
                v-model="search"
                :maxlength="32"
                :minlength="2"
                type="search"
                placeholder="Cari Judul dan Konten"
                debounce="500"
              />
            </b-input-group>
            <b-button
              id="filter-popover"
              variant="primary"
              size="md"
              class="w-[40px] h-[40px] d-flex align-items-center justify-content-center p-0"
              @click="showFilter"
            >
              <div class="w-16 h-16 d-flex align-items-center justify-content-center">
                <img
                  src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/filter-search.svg"
                  alt="filter"
                  width="16"
                  height="16"
                >
              </div>
            </b-button>
            <b-button
              variant="primary"
              size="md"
              class="!flex items-center justify-center gap-2 !px-6 !py-3"
              @click="addSystemUpdateLog"
            >
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/add.svg"
                alt="filter"
                width="16"
                height="16"
              >
              <span>Buat</span>
            </b-button>
          </div>
        </b-form-group>
        <ul
          v-if="isFilterShow"
          class="d-block position-absolute bg-[#f9f9f9] z-10 text-black font-medium text-[12px] pb-1 mt-5 shadow-lg border-none rounded"
        >
          <div class="text-black pl-2 py-1 text-[16px] border">
            Filter
          </div>
          <div class="hover:bg-[#FCD4BE]">
            <button
              id="popoverNotif"
              variant="outline-primary"
              class="btn btn1 rounded-none mb-1 d-flex"
            >
              <span>Status</span>
            </button>
            <BPopover
              target="popoverNotif"
              triggers="focus"
              placement="left"
            >
              <BFormCheckboxGroup v-model="selectedStatus">
                <div
                  v-for="(item, index) in statusList"
                  :key="index"
                >
                  <BFormCheckbox
                    :id="'filter_' + index"
                    :value="item.value"
                    class="mt-1"
                  >
                    <div class="text-black">
                      {{ item.text }}
                    </div>

                  </BFormCheckbox>
                </div>
              </BFormCheckboxGroup>
            </BPopover>
          </div>
          <hr>
          <div class="hover:bg-[#FCD4BE]">
            <date-range-picker
              ref="picker"
              v-model="dateRange"
              :locale-data="locale"
              :ranges="ranges"
              :opens="'left'"
              control-container-class="border-0"
            >
              <template v-slot:input="picker">
                <div class="d-flex btn">
                  <span>Date Created</span>
                </div>
                <span class="d-none">{{ picker }}</span>
              </template>
            </date-range-picker>
          </div>
          <hr>
          <div class="d-flex px-2 mt-2 justify-content-between">
            <b-button
              variant="outline-primary"
              size="sm"
              class="me-1 d-flex justify-items-start"
              @click="resetFilter()"
            >
              Reset
            </b-button>
            <b-button
              variant="primary"
              size="sm"
              class="me-1 d-flex justify-items-end"
              @click="applyFilter()"
            >
              Apply
            </b-button>
          </div>
        </ul>
      </div>
    </div>
    <BOverlay
      variant="light"
      :show="isLoading"
      spinner-variant="primary"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <BTable
        :fields="fields"
        :items="items"
        responsive
        tbody-tr-class="hover:bg-slate-100 transition-colors duration-300 cursor-pointer border rounded-lg"
        @row-clicked="(item, _, e) => handleAction(item)"
      >
        <template #head(checkbox)>
          <div class="d-flex justify-content-center pl-2">
            <BCheckbox
              v-model="allSelected"
              :indeterminate="indeterminate"
              @change="selectAll"
            />
          </div>
        </template>
        <template #cell(checkbox)="data">
          <div class="d-flex justify-content-center pl-2">
            <BCheckbox
              v-model="selected"
              :value="data.item"
              @change="select()"
            />
          </div>
        </template>
        <template #cell(no)="data">
          {{ (currentPage - 1) * totalPerPage + data.index + 1 }}
        </template>
        <template #cell(title)="data">
          <div>{{ data.item.title }}</div>
          <div class="text-[#828282] flex gap-5 items-center">
            <div>{{ DDMMMMYYYY(data.item.date) }}</div>
          </div>
        </template>
        <template #cell(status)="data">
          <span
            :class="classStatus(data.item.status)"
            class="font-medium"
          >
            {{ labelStatus(data.item.status) }}
          </span>
        </template>
        <template #cell(action)="data">
          <span
            class="text-[#08A0F7] cursor-pointer underline"
            @click.stop="handleAction(data.item)"
          >
            Detail
          </span>
        </template>

      </BTable>
    </BOverlay>
    <BRow class="mt-1">
      <BCol
        cols="12"
        class="flex flex-col md:flex-row justify-between bg-[#fafafa] items-center rounded p-1 gap-[12px] md:gap-0"
      >
        <div class="bg-light d-flex justify-content-center align-items-center p-50 rounded">
          <span class="text-black mr-50">List per page: </span>
          <BButton
            v-for="page in optionsPage"
            :key="page"
            class="btn-icon"
            size="sm"
            :variant="totalPerPage === page ? 'primary' : 'flat-dark'"
            @click="setPerPage(page)"
          >
            {{ page }}
          </BButton>
        </div>

        <div class="d-flex align-items-center gap-2">
          <span class="text-black font-medium mr-2">Page {{ currentPage }} of {{ totalPages }}</span>
          <button
            class="custom-page-btn"
            :disabled="currentPage <= 1"
            @click="currentPage = currentPage - 1"
          >
            <feather-icon
              size="16"
              icon="ChevronLeftIcon"
            />
          </button>
          <button
            class="custom-page-btn"
            :disabled="currentPage <= 1"
            @click="currentPage = 1"
          >
            <feather-icon
              size="16"
              icon="ChevronsLeftIcon"
            />
          </button>
          <button
            class="custom-page-btn"
            :disabled="currentPage >= totalPages"
            @click="currentPage = currentPage + 1"
          >
            <feather-icon
              size="16"
              icon="ChevronRightIcon"
            />
          </button>
          <button
            class="custom-page-btn"
            :disabled="currentPage >= totalPages"
            @click="currentPage = totalPages"
          >
            <feather-icon
              size="16"
              icon="ChevronsRightIcon"
            />
          </button>
        </div>
      </BCol>
    </BRow>
    <ModalDelete
      :loading="isDeleting"
      @confirm="handleDeleteConfirm"
    />
  </BCard>
</template>

<script>
import {
  LABELDAY, LABELMONTH, YEAR_MONTH_DAY, DDMMMMYYYY,
} from '@/libs/filterDate'
import moment from 'moment'
import {
  today,
  last7,
  last2,
  last30,
  last60,
  firstDateOfMonth,
  lastDateOfMonth,
  lastMonth,
  lastDateOfLastMonth,
} from '@/store/helpers'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { openApiAxiosIns, collaboratorAxiosIns } from '@/libs/axios'
import { fieldListUpdateLog } from '../config'
import ModalDelete from './ModalDelete.vue'

export default {
  components: {
    DateRangePicker,
    ModalDelete,
  },
  data() {
    return {
      search: '',
      isFilterShow: false,
      YEAR_MONTH_DAY,
      DDMMMMYYYY,
      picker: {
        startDate: firstDateOfMonth,
        endDate: lastDateOfMonth,
      },
      locale: {
        format: 'dd/mm/yyyy',
        daysOfWeek: LABELDAY,
        monthNames: LABELMONTH,
      },
      ranges: {
        'Last Week': [last7, today],
        'This Month': [firstDateOfMonth, today],
        'Last Month': [lastMonth(1), lastDateOfLastMonth],
        'Custom Range': [today, today],
      },
      today,
      last7,
      last2,
      last30,
      firstDateOfMonth,
      lastDateOfMonth,
      dateRange: {
        startDate: null,
        endDate: null,
      },
      selectedStatus: [],
      statusList: [
        { text: 'Draft', value: 'draft' },
        { text: 'Selesai', value: 'published' },
      ],
      fields: fieldListUpdateLog,
      items: [],
      selected: [],
      allSelected: false,
      isLoading: false,
      status: 0,
      indeterminate: false,
      currentPage: 1,
      optionsPage: [20, 50, 75],
      totalPerPage: 20,
      totalRows: 0,
      isDeleting: false,
    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.totalRows / this.totalPerPage))
    },
  },
  watch: {
    search() {
      this.currentPage = 1
      this.getListLog()
    },
    currentPage() {
      this.getListLog()
    },
    dateRange() {
      this.currentPage = 1
      this.getListLog()
    },
    selectedStatus() {
      this.currentPage = 1
      this.getListLog()
    },
  },
  mounted() {
    this.getListLog()
  },
  methods: {

    showFilter() {
      this.isFilterShow = !this.isFilterShow
    },
    async getListLog() {
      this.isLoading = true
      const url = '/user/api/v1/admin/system-update-log'
      const params = {
        search: this.search || undefined,
        status: this.selectedStatus.length ? this.selectedStatus.join(',') : undefined,
        start_date: this.dateRange.startDate ? moment(this.dateRange.startDate).format('YYYY-MM-DD') : undefined,
        end_date: this.dateRange.endDate ? moment(this.dateRange.endDate).format('YYYY-MM-DD') : undefined,
        page: this.currentPage,
        limit: this.totalPerPage,
      }

      try {
        const res = await openApiAxiosIns.get(url, { params })
        this.items = (res.data.data.data || []).sort((a, b) => moment(b.date).diff(moment(a.date)))
        this.totalRows = res.data.data.total
      } catch {
        this.$toast_error({ message: 'Gagal Mengambil Data' })
      } finally {
        this.isLoading = false
      }
    },
    deleteSelected() {
      this.$bvModal.show('modal-delete-log')
    },
    async handleDeleteConfirm() {
      this.isDeleting = true
      const url = '/user/api/v1/admin/system-update-log'
      const data = {
        ids: this.selected.map(item => Number(item.id)),
      }

      try {
        await openApiAxiosIns.delete(url, { data })
        this.$toast_success({ message: 'Berhasil Menghapus Data' })
        this.selected = []
        this.allSelected = false
        this.indeterminate = false
        this.$bvModal.hide('modal-delete-log')
        this.getListLog()
      } catch {
        this.$toast_error({ message: 'Gagal Menghapus Data' })
      } finally {
        this.isDeleting = false
      }
    },
    addSystemUpdateLog() {
      this.$router.push('/openapi/system-update-log/create').catch(() => {})
    },
    handleAction(item) {
      this.$router.push(`/openapi/system-update-log/${item.id}`).catch(() => {})
    },
    setPerPage(page) {
      this.totalPerPage = page
      this.currentPage = 1
      this.getListLog()
    },
    resetFilter() {
      this.selectedStatus = []
      this.dateRange = {
        startDate: null,
        endDate: null,
      }
      this.search = ''
      this.currentPage = 1
      this.getListLog()
      this.isFilterShow = false
    },
    applyFilter() {
      this.currentPage = 1
      this.getListLog()
      this.isFilterShow = false
    },
    selectAll(checked) {
      this.selected = checked ? this.items.slice() : []
    },
    select() {
      this.allSelected = this.selected.length === this.items.length
      this.indeterminate = this.selected.length > 0 && this.selected.length < this.items.length
    },
    labelStatus(status) {
      if (status === 'draft') {
        return 'Draft'
      }
      return 'Selesai'
    },
    classStatus(status) {
      if (status === 'draft') {
        return 'text-[#828282] bg-[#F5F5F5] rounded-pill px-1 py-[5px]'
      }
      return 'text-[#34A770] bg-[#F0FDF4] rounded-pill px-1 py-[5px]'
    },
  },
}
</script>

<style scoped>
.custom-page-btn {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  color: #333;
  transition: all 0.15s ease;
}
.custom-page-btn:hover:not(:disabled) {
  background: #f5f5f5;
  border-color: #ccc;
}
.custom-page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
</style>
